import api from '@/api'
import store from '@/store'
import wx from 'weixin-js-sdk'
export default {
  getWXSign() {
    api
      .getsignatureApi({
        url: window.location.href.split('#')[0],
        ExhCode: store.state.ExhCode
      })
      .then((res) => {
        if (res.code === 200) {
          const wxParam = {
            ...res.data.sign,
            sTitle: '第十五届中国（广饶）国际橡胶轮胎暨汽车配件展览会',
            sDesp: '2025轮胎展全面升级，邀您共赴行业盛会！',
            sImg: 'https://pohto-imgs.oss-cn-beijing.aliyuncs.com/19/share.png'
          }
          wxConfig(wxParam)
        }
      })
  }
}
const wxConfig = (data) => {
  const configParam = {
    debug: false, //  开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId, //  必填，公众号的唯一标识
    timestamp: data.timestamp, //  必填，生成签名的时间戳
    nonceStr: data.nonceStr, //  必填，生成签名的随机串
    signature: data.signature, //  必填，签名，见附录1
    jsApiList: [
      'hideMenuItems',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'chooseImage',
      'scanQRCode',
      'getLocalImgData',
      'uploadImage',
      'downloadImage'
    ] //  必填，需要使用的JS接口列表
  }
  wx.config(configParam)

  wx.ready(() => {
    wx.hideMenuItems({
      menuList: [
        'menuItem:exposeArticle', //  举报
        'menuItem:setFont', //  调整文字
        // 'menuItem:dayMode', // 日间模式
        // 'menuItem:nightMode', // 夜间模式
        // 'menuItem:refresh', // 刷新
        // 'menuItem:profile', // 查看公众号（已添加）
        // 'menuItem:addContact', // 查看公众号（未添加）
        // 'menuItem:share:appMessage', // 发送给朋友
        // 'menuItem:share:timeline', // 分享到朋友圈
        'menuItem:share:qq', // 分享到QQ
        'menuItem:share:weiboApp', // 分享到Weibo
        // 'menuItem:favorite', // 收藏
        'menuItem:share:facebook', // 分享到FB
        'menuItem:share:QZone', // 分享到 QQ 空间
        'menuItem:jsDebug', // 调试
        'menuItem:editTag', // 编辑标签
        'menuItem:delete', // 删除
        'menuItem:copyUrl', // 复制链接
        'menuItem:originPage', // 原网页
        'menuItem:readMode', // 阅读模式
        'menuItem:openWithQQBrowser', // 在QQ浏览器中打开
        'menuItem:openWithSafari', // 在Safari中打开
        'menuItem:share:email', // 邮件
        'menuItem:share:brand' // 一些特殊公众号
      ] //  要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
    })
    // const toLink = `${
    //   window.location.href.split('#')[0]
    // }#/index?ExhCode=${sessionStorage.getItem('ExhCode')}`
    let toLink = window.location.href
    // if (toLink.indexOf('&edit=') !== -1) {
    //   toLink = toLink.split('&edit=')[0]
    // }
    // if (toLink.indexOf('yqh') !== -1 && toLink.indexOf('yqhShare') === -1) {
    //   toLink = toLink.replace('yqh', 'yqhShare')
    // }
    console.log(toLink, '1111')
    // 分享到朋友圈
    const actor = sessionStorage.getItem('actor')
      ? JSON.parse(sessionStorage.getItem('actor'))
      : null
    const sTitle = actor
      ? `${actor.actor_Name}诚邀您参加第十五届中国（广饶）国际橡胶轮胎暨汽车配件展览会`
      : data.sTitle
    console.log(sTitle, '222')
    wx.onMenuShareTimeline({
      title: sTitle, //  分享标题
      link: toLink, //  分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: data.sImg, //  分享图标
      success: function () {
        //  用户确认分享后执行的回调函数
      },
      cancel: function () {
        //  用户取消分享后执行的回调函数
      }
    })

    // 分享给朋友
    wx.onMenuShareAppMessage({
      title: sTitle, //  分享标题
      desc: data.sDesp, //  分享描述
      link: toLink, //  分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: data.sImg, //  分享图标
      type: 'link', //  分享类型,music、video或link，不填默认为link
      dataUrl: '', //  如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        //  用户确认分享后执行的回调函数
      },
      cancel: function () {
        //  用户取消分享后执行的回调函数
      }
    })
  })
}
